import { InvoiceTaxBase } from "../../invoicing/abstract/invoice-tax-base.model";


export class SalesInvoiceTax extends InvoiceTaxBase {

    static override CLASS_NAME: string = 'SalesInvoiceTax';

}
